module.exports = __webpack_public_path__ + "img/img-4.f14fe5a9.webp";